/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Biblioteca', Biblioteca);

    /* @ngInject */
    function Biblioteca($resource) {
        return $resource('api/admin/biblioteca/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/biblioteca/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/biblioteca/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/biblioteca/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/biblioteca/findUsedLetters'
            }
            ,
            'findAllPaises': {
                method: 'GET',
                isArray: false,
                url: 'api/public/biblioteca/findAllPaises'
            }
        });
    }
})();
